'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fRouterHistoryService = function () {
  function fRouterHistoryService($state) {
    _classCallCheck(this, fRouterHistoryService);

    this._ = { $state: $state };
    this.history = [];
  }

  _createClass(fRouterHistoryService, [{
    key: 'back',
    value: function back(force) {
      var target = this.history.pop();
      this.last = true;
      if (target) {

        if (target.state === 'feiseanna.one.admin.registration') {
          force = true;
        }

        return this._.$state.go(target.state, target.params, { reload: force });
      }

      return this._.$state.go('dashboard');
    }
  }, {
    key: 'save',
    value: function save(state, params) {
      if (!this.last) {
        this.history.push({ state: state, params: params });
      }

      this.last = false;
    }
  }]);

  return fRouterHistoryService;
}();

exports.default = angular.module('ifeis.router-history', ['ui.router']).service('fRouterHistoryService', fRouterHistoryService);


//////////////////
// WEBPACK FOOTER
// ./router-history/index.js
// module id = 48
// module chunks = 0